import { Link, Navigate, useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import { getGuide } from '../data/guides';

const GuideArticle = () => {
  const { slug } = useParams();
  const guide = getGuide(slug);
  if (!guide) return <Navigate to="/404" replace />;

  return (
    <article className="min-h-screen bg-white py-16">
      <SEO title={`${guide.title} | Video Vault`} description={guide.description} path={`/guias/${guide.slug}`} type="article" />
      <div className="container mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Link to="/guias" className="text-sm text-gray-600 underline">← Todas las guías</Link>
        <h1 className="mb-5 mt-6 text-4xl font-bold leading-tight md:text-5xl">{guide.title}</h1>
        <p className="mb-3 text-xl text-gray-600">{guide.description}</p>
        <p className="mb-12 text-sm text-gray-500">Por el equipo de Video Vault · Actualizada el 10 de agosto de 2026 · {guide.readTime}</p>
        <div className="space-y-10">
          {guide.sections.map(([heading, body]) => <section key={heading}><h2 className="mb-3 text-2xl font-bold">{heading}</h2><p className="text-lg leading-8 text-gray-700">{body}</p></section>)}
        </div>
        <aside className="mt-12 rounded-lg border-2 bg-gray-50 p-6"><h2 className="mb-2 text-xl font-bold">Recordatorio de uso responsable</h2><p className="text-gray-700">Descargá únicamente contenido propio, de dominio público o para el que tengás autorización. Respetá los términos de la plataforma y los derechos de las personas creadoras.</p></aside>
      </div>
    </article>
  );
};

export default GuideArticle;
